import { useEffect, useState } from 'react'
import './Loader.css'

const LOADING_ANIMATION_DURATION = 2000

interface Props {
  areTranslationsLoading: boolean
}

export function Loader(props: Props) {
  const [didAnimationEnd, setDidAnimationEnd] = useState(false)
  const [isLoaderVisible, setIsLoaderVisible] = useState(false)

  useEffect(() => {
    if (props.areTranslationsLoading) {
      setDidAnimationEnd(false)

      setTimeout(() => {
        setDidAnimationEnd(true)
      }, LOADING_ANIMATION_DURATION)
    }
  }, [props.areTranslationsLoading])

  useEffect(() => {
    if (!props.areTranslationsLoading && didAnimationEnd) {
      setIsLoaderVisible(false)
    } else {
      setIsLoaderVisible(true)
    }
  }, [props.areTranslationsLoading, didAnimationEnd])

  return (
    <div className={`Loader${isLoaderVisible ? ' visible' : ''}`}>
      <span>IT’S</span>
      <span>JUST</span>
      <span>ACNE</span>
      <div className="stripe" />
    </div>
  )
}
